module.exports = __webpack_public_path__ + "img/hub_spot.b07910b9.svg";